import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack
} from "@mui/material";
import { NumericFormat, PatternFormat } from "react-number-format";
import { formatDate } from "./CommonFunctions";
const getNowWithSeconds = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T${hh}:${min}:00`; // seconds hardcoded
};
const AddInquiryDialog = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    description: "",
    callDate: getNowWithSeconds(),
    requiredDate: formatDate(new Date())
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const normalizedValue =
    name === "date" && value.length === 16  // 'YYYY-MM-DDTHH:mm'
      ? value + ":00"
      : value;
    setFormData((prev) => ({
      ...prev,
      [name]: normalizedValue,
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
    onClose();
    setFormData({ name: "", phoneNumber: "", description: "", date: "" });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Inquiry</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            name="name"
            label="Name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            
          />
          <PatternFormat
  customInput={TextField}
  name="phoneNumber"
  label="Phone Number"
  format="(###) ###-####"
  allowEmptyFormatting
  mask="_"
  value={formData.phoneNumber}
  fullWidth
  required
  onValueChange={(values) => {
    setFormData((prev) => ({
      ...prev,
      phoneNumber: values.value, // only numeric digits: e.g., "9876543210"
    }));
  }}
/>


          <TextField
            name="description"
            label="Description"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />
          <TextField
            name="callDate"
            label="Date & Time"
            type="datetime-local"
            value={formData.callDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <TextField
            name="requiredDate"
            label="Reservation Date"
            type="date"
            value={formData.requiredDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddInquiryDialog;
